import { BoxGuardService } from "./box";
import { CloudGuardService } from "./cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { GuardService } from "./base";
import environment from "@/config";

export default getService<GuardService>(environment.nexus, {
    box: new BoxGuardService(),
    cloud: new CloudGuardService(),
});
